import React from "react";
import { useParams } from "react-router-dom";
import ChildDashboardChartComponent from "../components/child/1_ChildDashboardChartComponent";

const ChildRouter = () => {
  const { drilllevel } = useParams();
  return <ChildDashboardChartComponent metricid={drilllevel} />;
};

export default ChildRouter;
